import { Droplets, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function ConsumablesPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Consumables</h1>
          <p className="text-sm text-foreground-muted">Track glue, desiccant, grease, and more</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Add Consumable
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Droplets className="h-10 w-10" />}
          title="No consumables yet"
          description="Track consumable items like glue sticks, desiccant packs, grease, and cleaning supplies."
          actionLabel="Add Consumable"
          onAction={() => {
            // TODO: Open add consumable modal
          }}
        />
      </div>
    </div>
  );
}
